import DataLoadError, {
  DataLoadDefaultErrors,
} from "../../../../../utils/data-load-error/data-load-error";

export enum BillingsOrderCargoTaxiCreateErrorType {
  BAD_REQUEST = "BAD_REQUEST",
}

export type BillingsOrderCargoTaxiCreateBadRequestError = DataLoadError<
  BillingsOrderCargoTaxiCreateErrorType.BAD_REQUEST,
  {}
>;

type BillingsOrderCargoTaxiCreateError =
  | DataLoadDefaultErrors
  | BillingsOrderCargoTaxiCreateBadRequestError;

export default BillingsOrderCargoTaxiCreateError;
